import { SystemField } from "./system-field";

export class SaleorderPrepayment extends SystemField{
     
     sale_order_id?:string;
     receipt_id?:string;
     amount?:number;
     status?:string;
}
